// extracted by mini-css-extract-plugin
export default {"container":"OnBoardingContent_container__xv6o+","capOneLink":"OnBoardingContent_capOneLink__AnD-1","loader":"OnBoardingContent_loader__9XmBc"};